export const CHANGE_COUNTRY = 'countryChange'
export const CHANGE_RECEIPT_ID = 'setReceiptId'
